import './select2';

export default class Select {
    constructor() {
        this.dom = {
            $: window.$,
            jQuery: window.$,
            $select: $('select:not([data-select2-id])')
        };

        if (this.dom.$select) {
            this.init();
        }
    }

    init() {
        this.dom.$select.each((_, select) => {
            let $select = $(select);
            let changeMeClass = '';

            $select.select2({
                width: '100%',
                allowClear: $select.data('allowclear'),
                placeholder: $select.data('label'),
                minimumResultsForSearch: -1,
                dropdownAutoWidth: 'auto',
                templateResult: formatData,
                templateSelection: formatData
            }).on('select2:unselecting', function () {
                $(this).data('unselecting', true);
            }).on('select2:opening', function (e) {
                if ($(this).data('unselecting')) {
                    $(this).removeData('unselecting');
                    e.preventDefault();
                }
            }).delay(100, function () {
                //Setup initial class of parent
                changeMeClass = $select.next('.select2-container').find('.select2-selection').attr("class");
                setOptClass();
            });

            function formatData(thisData, thisContainer) {
                if (thisData.element) {
                    if ($(thisContainer).hasClass('select2-selection__rendered')) {
                        $(thisContainer).attr('class', 'select2-selection__rendered ' + $(thisData.element).attr("class"));
                    } else {
                        $(thisContainer).addClass($(thisData.element).attr("class"));
                    }
                }
                let $returnString = thisData.text;
                if ($(thisData.element).data("select2-prefix")) {
                    $returnString = $("<div class='select2-prefix'>" + $(thisData.element).data("select2-prefix") + "</div><div>" + $returnString + "</div>");
                }
                return $returnString;
            }

            $select.parent().find('.select2-selection__arrow').append(`
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.61 11.306">
                    <path stroke="#adda43" stroke-width="3px" fill="none" stroke-linecap="round" stroke-linejoin="round" d="M353.377,1028.358l8.305-8.305-8.305-8.305" transform="translate(1029.857 -351.877) rotate(90)"/>
                </svg>
            `);

            $select.on("change", setOptClass);

            //Add selected class to parent
            function setOptClass() {
                $select.next('.select2-container').find('.select2-selection').attr('class', changeMeClass + " " + $select.find('option:selected').attr('class'));
            }
        });

        //Allow a separator to be added after the first option
        $('select.show-separator').on('select2:open', (e) => {
            setTimeout(function () {
                $('#select2-' + $(e.currentTarget).attr('id') + '-results li:first-child').addClass('firstOption');
            }, 100);
        });
    }
}
